import React from "react";
import Chart from "react-apexcharts";
import { Card } from "react-bootstrap";
import { GraphCardsHeader } from "@ui";

const FullStackBarChart = ({
  title,
  series,
  labels,
  graphColor,
  tooltip = "",
  exportCSVHeading = "Title,",
}) => {
  const chartConfig = {
    series: series,
    options: {
      chart: {
        type: "bar",
        stacked: true,
        toolbar: { show: false },
      },
      plotOptions: {
        bar: {
          horizontal: true,
          dataLabels: {
            total: {
              offsetX: 5,
              enabled: false,
              style: {
                fontSize: "12px",
                colors: ["#F00"],
              },
            },
          },
        },
      },
      states: {
        normal: {
          filter: {
            type: "none",
          },
        },
        hover: {
          filter: {
            type: "darken",
            value: 0.8,
          },
        },
      },
      dataLabels: {
        enabled: true,
        formatter: (val) => `${val}%`,
        style: {
          fontSize: "12px",
          colors: ["#fff"],
        },
      },
      xaxis: {
        categories: labels,
        min: 0,
        max: 100,
        labels: {
          formatter: (val) => `${val}%`,
        },
      },
      yaxis: {
        labels: { show: true },
      },
      colors: graphColor || [],
      legend: {
        show: true,
        position: "bottom",
        markers: {
          width: 12,
          height: 12,
          radius: 12,
          shape: "round",
          offsetX: -5,
        },
        itemMargin: {
          horizontal: 15,
        },
      },
      tooltip: {
        enabled: true,
        y: {
          formatter: (val) => `${val}%`,
        },
      },
      grid: { show: false },
    },
  };

  function exportCSV() {
    let csvContent =
      exportCSVHeading + series.map((s) => s.name).join(",") + "\n";
    labels.forEach((category, index) => {
      let row = [category];
      series.forEach((series) => {
        row.push(series.data[index]);
      });
      csvContent += row.join(",") + "\n";
    });
    var blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    var link = document.createElement("a");
    if (link.download !== undefined) {
      var url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", "chart_data.csv");
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }

  return (
    <Card>
      <GraphCardsHeader
        title={title}
        tooltip={tooltip}
        showDownloadButtons={true}
        needCSVDownload={true}
        downloadCSV={exportCSV}
      />
      <Card.Body>
        <Chart
          options={chartConfig.options}
          series={chartConfig.series}
          type="bar"
          height={150}
          width="100%"
        />
      </Card.Body>
    </Card>
  );
};

export default FullStackBarChart;
